import {TranslatePipe} from '@brunata-angular/util';
import {ChangeDetectionStrategy, Component, EventEmitter, Output} from '@angular/core';

@Component({
    selector: 'app-choose-between-upload-and-manual-reporting',
    templateUrl: './choose-between-upload-and-manual-reporting.component.html',
    styleUrls: ['./choose-between-upload-and-manual-reporting.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslatePipe],
})
export class ChooseBetweenUploadAndManualReportingComponent {
    @Output() reportingType = new EventEmitter<'ConsumerAttachments' | 'ConsumerReporting'>();
    setPreferredType(type: 'ConsumerAttachments' | 'ConsumerReporting'): void {
        this.reportingType.next(type);
    }
}
